(function(w,d){
  'use strict';
  const paths={home:'','vw-camera':'products/achteruitrij-camera','vw-screen':'products/volkswagen-carplay-scherm',camera:'products/achteruitrijcamera-mini',touchscreen:'products/volvo-touch-screen-1',auto:'pages/carplaybox',hulp:'pages/contact',faq:'pages/faq',bestelling:'pages/bekijk-de-status-van-uw-bestelling','werken-bij':'pages/vacatures',ervaringen:'pages/review',bedrijven:'pages/partner-platform-introduction',reseller:'pages/partner-reseller',installatiepartner:'pages/installatie-partner-worden',retour:'pages/retour',klachten:'pages/klachten',verzending:'policies/shipping-policy',voorwaarden:'policies/terms-of-service',privacy:'policies/privacy-policy',retourbeleid:'policies/refund-policy'};
  const aliases={carplaybox:'auto',help:'hulp',returns:'retour',afspraak:'hulp',uitbreiden:'hulp',herroepen:'retour','page:Kennisbank':'kennisbank','page:Fleet & distributeurs':'fleet','page:CarPlayBox of Dongle?':'vergelijking','page:Zakelijk contact':'hulp'};
  const otherPaths={kennisbank:'blogs/kennisbank',fleet:'pages/fleet-distributeurs',vergelijking:'pages/carplaybox-of-carplay-dongle'};
  const root=(w.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
  const title=d.title;
  const initial=d.querySelector('#main [data-co-content-route]');
  const documentRoute=initial?.dataset.coContentRoute||Object.keys(paths).find(key=>trim(root+paths[key])===trim(w.location.pathname))||null;
  const source=initial?.outerHTML||'';
  const normalize=route=>aliases[route]||route;
  function trim(path){return path.replace(/\/$/,'')||'/';}
  function url(route){
    const key=normalize(route)==='camera'&&w.COVWCamera?.matches(w.COVWCamera.active())?'vw-camera':normalize(route),path=paths[key]??otherPaths[key];
    if(path===undefined)return null;
    const target=new URL(root+path,w.location.origin),current=new URL(w.location.href);
    for(const param of ['preview_theme_id','preview_key','_fd','pb'])if(current.searchParams.has(param))target.searchParams.set(param,current.searchParams.get(param));
    if(key==='vw-screen')for(const param of ['model','generation','radio','variant'])if(current.searchParams.has(param))target.searchParams.set(param,current.searchParams.get(param));
    if(route==='herroepen')target.hash='herroepen';
    return target.pathname+target.search+target.hash;
  }
  function sameDocument(destination){return trim(new URL(destination,w.location.origin).pathname)===trim(w.location.pathname);}
  function navigationDestination(route){
    const destination=url(route);
    if(destination)return destination;
    const fragments=['auto','handleidingen','verhaal','installatiepunten','zakelijke-voorwaarden','ai-box','pnd','vw-screen','dashcam','dashcam-samenstellen','camera','touchscreen','touchscreen-bestellen'];
    if(documentRoute&&documentRoute!=='home'&&fragments.includes(route))return root+'#'+route;
    return null;
  }
  function beforeNavigate(route){
    const destination=navigationDestination(route);
    if(!destination||sameDocument(destination))return false;
    w.location.assign(destination);return true;
  }
  function migrateHash(vehicleReady=false){
    const route=w.location.hash.slice(1),destination=route&&navigationDestination(route);
    if(!destination)return false;
    // Bind and save the exact vehicle before leaving an old product#accessory link.
    if(!vehicleReady&&!documentRoute&&w.location.pathname.includes('/products/')&&['camera','touchscreen'].includes(route))return false;
    if(!sameDocument(destination)){w.location.replace(destination);return true;}
    if(route!=='herroepen')w.history.replaceState(w.history.state,'',w.location.pathname+w.location.search);
    return false;
  }
  function rewriteLinks(scope=d){
    scope.querySelectorAll('a[href]').forEach(a=>{
      const raw=a.getAttribute('href');
      let parsed;try{parsed=new URL(raw,w.location.href);}catch(_){return;}
      if(parsed.origin!==w.location.origin)return;
      if(a.closest('.site-header')&&(a.dataset.vwcCameraLink!==undefined||parsed.hash==='#camera'||['camera','vw-camera'].some(key=>trim(parsed.pathname)===trim(root+paths[key])))){a.dataset.vwcCameraLink='';a.setAttribute('href',url('camera'));return;}
      const destination=(raw.startsWith('#')||trim(parsed.pathname)===trim(root)||trim(parsed.pathname)===trim(w.location.pathname))&&navigationDestination(parsed.hash.slice(1));
      if(destination)a.setAttribute('href',destination);
    });
  }
  function mount(route){
    rewriteLinks();
    if(!documentRoute&&['camera','touchscreen'].includes(route)&&w.COShopifyBridge?.isProductPage)migrateHash(true);
    if(route===documentRoute||route==='home'&&trim(w.location.pathname)===trim(root))d.title=title;
  }
  function preserveDOM(route){return !['auto','camera','touchscreen'].includes(route)&&route!=='home'&&route===documentRoute&&!!d.querySelector('#main [data-co-content-route]');}
  function preserveOnError(){
    if(!source)return false;
    const main=d.getElementById('main');
    if(main&&!main.querySelector('[data-co-content-route]'))main.innerHTML=source;
    rewriteLinks();d.title=title;return true;
  }
  w.COContentRoutes={paths,aliases,url,normalize,documentRoute,initialRoute:documentRoute==='home'&&w.location.hash?null:documentRoute,preserveDOM,preserveOnError,beforeNavigate,migrateHash,mount,rewriteLinks};
  rewriteLinks();
})(window,document);
